export default "__VITE_ASSET__CRllh0km__"